import { combineReducers } from 'redux';
import LoginReducer from '../GlobalModules/Login/Reducers/LoginReducer';
import mainReducerData from './MainReducers';
export default combineReducers({
    LoginReducer,
    mainReducerData
})